import { render, staticRenderFns } from "./NxQualifications.vue?vue&type=template&id=0d4daba6&scoped=true"
import script from "./NxQualifications.vue?vue&type=script&lang=js"
export * from "./NxQualifications.vue?vue&type=script&lang=js"
import style0 from "./NxQualifications.vue?vue&type=style&index=0&id=0d4daba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4daba6",
  null
  
)

export default component.exports